module.exports = __webpack_public_path__ + "img/ProductoSinImagen.04a209b9.jpg";